<template>
  <div>
    <div class="header">
      <div class="header_info">
        <div class="header_one">
          岳泰兴智慧导诊导航一体机

        </div>
        <div class="header_one">岳泰兴智慧导诊机器人</div>
        <div class="header_two">
          <div class="header_two_info">
            新形势
          </div>
          <div class="header_two_info">
            多功能
          </div>
          <div class="header_two_info">
            易维护
          </div>
          <div class="header_two_info">
            个性化服务
          </div>
        </div>
        <div class="header_three">
          聚焦"优化就医流程”核心需求，通过人工智能物联网技术，连接患者与医院服务，解决”挂号难、找科室难、信息查询难"等痛点。
        </div>
        <div class="header_four" @click="select">
          立即咨询
        </div>
      </div>
    </div>
    <div class="lightModuleOuterContent">
      <div class="lightModuleOuterContent_text">
       <img src="/intelligentGuidance/17.png">
        <div class="wenzi">产品功能</div>
        <img src="/intelligentGuidance/18.png">
      </div>
      <div class="lightModuleOuterContent_title">
        重新定义导诊体验的四大核心优势
      </div>
      <div class="formTabButtonList">
        <div :class="toTextIndex === index ?'formTabButtonInfo blue':'formTabButtonInfo'" v-for="(item,index) in textList" :key="index" @mouseover="toText(index)" @click="toText(index)">
          <div class="item_left"></div>
          <div class="item">{{item}}</div>
          <div class="item_right"></div>
        </div>
      </div>
      <div class="textListInfo_list" >
        <div class="text_list_left">
          <div class="text_list_text"> {{textListInfo[toTextIndex].text}}</div>
          <div class="text_list_title"> {{textListInfo[toTextIndex].title}}</div>
          <div class="text_list_three" @click="select">了解详情<img src="/intelligentGuidance/19.png"></div>
        </div>
        <div class="image_right" v-if="!textListInfo[toTextIndex].img2">
          <el-image
              class="imgInfo" :src="textListInfo[toTextIndex].img"
              :preview-src-list="[textListInfo[toTextIndex].img]">
          </el-image>
        </div>
        <div class="image_right2" v-if="textListInfo[toTextIndex].img2">
          <el-image
              class="imgInfo" :src="textListInfo[toTextIndex].img"
              :preview-src-list="[textListInfo[toTextIndex].img]">
          </el-image>
          <el-image
              class="imgInfo" :src="textListInfo[toTextIndex].img2"
              :preview-src-list="[textListInfo[toTextIndex].img2]">
          </el-image>
        </div>
      </div>
    </div>


    <div class="three">
     <div class="three_info">
       <div class="three_left">
         <div class="three_left_name">
           产品优势及其特色
         </div>
         <div class="three_left_title">
           聚焦"优化就医流程"核心需求，通过人工智能、物联网技术，连接患者与医院服务，解决“挂号难、找科室难、信息查询难”等痛点
         </div>
       </div>
       <div class="three_right">
         <div class="three_right_info">
           <img src="/intelligentGuidance/8.png">
           <div class="three_text">精准</div>
           <div class="three_title">根据患者症状，智慧导诊机智能推荐科室，避免盲目挂号，减少挂错号情况。</div>
         </div>
         <div class="three_right_info">
           <img style="width: 80px;height: 80px;margin-bottom: 10px" src="/intelligentGuidance/5.png">
           <div class="three_text">多元化</div>
           <div class="three_title">集导诊、科室医生查询、院内导航、健康宣教等功能于一体，一台设备满足患者就医多样化需求。</div>
         </div>
         <div class="three_right_info">
           <img style="width: 100px;height: 100px;margin-bottom: -10px" src="/intelligentGuidance/9.png">
           <div class="three_text">高效</div>
           <div class="three_title">智能导诊设备支持触屏和语音交互，患者可轻松自助服务。24小时在线，随时解答疑问</div>
         </div>
         <div class="three_right_info">
           <img src="/intelligentGuidance/11.png">
           <div class="three_text">多模拟交互</div>
           <div class="three_title">支持语音、文字、触控等多种交互方式，适应不同年龄、需求的患者,操作更便捷。</div>
         </div>
         <div class="three_right_info">
           <img style="width: 100px;height: 100px;margin-bottom: -10px" src="/intelligentGuidance/7.png">
           <div class="three_text">精准个性化</div>
           <div class="three_title">根据患者病情、历史就诊记录等:提供个性化导诊方案，提升就医体验。</div>
         </div>
         <div class="three_right_info">
           <img src="/intelligentGuidance/12.png">
           <div class="three_text">高效赋能</div>
           <div class="three_title">减少导诊人员工作量，提升导诊效率，降低医疗机构运营成本。</div>
         </div>
       </div>
     </div>
    </div>

    <div class="four">
      <div class="lightModuleOuterContent_text">
        <img src="/intelligentGuidance/17.png">
        <div class="wenzi">场景应用</div>
        <img src="/intelligentGuidance/18.png">
      </div>
      <div class="lightModuleOuterContent_title">
        高效智能，轻松掌推
      </div>
      <div class="four_image">

        <img src="/intelligentGuidance/15.png">
        <img src="/intelligentGuidance/16.png">
      </div>
    </div>
    <tail_menu></tail_menu>
    <div ref="brandConcept"></div>
  </div>
</template>

<script>
import tail_menu from "@/components/tail_menu";
export default {
  name: "intelligentGuidance",
  components:{
    tail_menu
  },
  data(){
    return{
      toTextIndex:0,
      textListInfo:[
        {
          text:'智能导诊',
          title:'根据患者症状匹配挂号科室，提供挂号科室荐，展示科室和专家信息，患者选择科室后可直接扫码挂号，减少医患资源错配。',
          img:'/intelligentGuidance/14.png',
          img2:'/intelligentGuidance/13.png',
        },
        {
          text:'科室信息查询',
          title:'提供便捷直观的科室信\n' +
              '息查询，包括科室基本信息、特色优势、就诊指南、医生团队介绍等帮助患者了解科室，提升就医效率和满意度助力医院品牌建设。',
          img:'/intelligentGuidance/3.png',
        },
        {
          text:'院内导航服务',
          title:'通过科室院内导航平面图，帮助患者快速定位目标科室位置，展示科室布局和周边环境，方便患者按图索骥，高效抵达就诊地点。',
          img:'/intelligentGuidance/6.png',
        },
        {
          text:'健康宣教服务',
          title:'向患者及家属普及医学知识和健康信息，引导理性就医，减少不必要就诊和检查，提升公众健康素养，促进健康生活方式形成，补充医患\n' +
              '沟通内容。',
          img:'/intelligentGuidance/2.png',
        },
      ],
      textList:[
        '智能导诊',
        '科室信息查询',
        '院内导航服务',
        '健康宣教服务'
      ]
    }
  },
  methods:{
    select(){
      this.$refs.brandConcept.scrollIntoView({ behavior: 'smooth' });
    },
    toText(index){
      this.toTextIndex = index
    },
  }
}
</script>

<style scoped lang="scss">
  .header{
    width: 100%;
    height: 600px;
    background-image: url('/intelligentGuidance/1.jpg');
    //background-size: 100% 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    .header_info{
      position: absolute;
      left: 12%;
      top: 12%;
      .header_one{
        font-size: 50px;
        color: white;
      }
      .header_two{
        display: flex;
        align-items: center;
        margin-top: 30px;
        color: white;
        .header_two_info{
          border-radius: 50px;
          background-color: rgba(255,255,255,0.4);
          margin-right: 10px;
          font-size: 15px;
          padding: 4px 16px;
        }
      }
      .header_three{
        max-width: 400px;
        margin-top: 30px;
        color: white;
      }
      .header_four{
        color: rgba(67,131,241,1);
        font-size: 18px;
        background: white;
        width: max-content;
        margin-top: 30px;
        border-radius: 100px;
        padding: 4px 28px;
        cursor: pointer;
      }
    }
  }

  .lightModuleOuterContent{
    background-image: url('/intelligentGuidance/4.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    border-bottom: 1px solid rgba(237, 237, 237, 1);
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 60px 60px 0 60px;
    .lightModuleOuterContent_text{
      display: flex;
      align-items: center;

      img{
        width: 100px;
      }
      .wenzi{
        font-size: 38px;
        font-weight: bold;
        color: rgb(51, 51, 51);
        margin-left: 40px;
        margin-right: 40px;
      }
    }
    .lightModuleOuterContent_title{
      color: rgba(16,16,16,1);
      font-size: 16px;
      margin-top: 10px;
    }
    .formTabButtonList{

      display: flex;
      justify-content: space-around;
      .formTabButtonInfo:nth-of-type(1){
        .item_left{
          width: 0;
          height: 0;
          border-radius: 20px 0 0 20px;
          background: rgba(9,90,249,1);
        }
        .item{
          padding-right: 20px;
        }
      }
      .formTabButtonInfo:nth-of-type(4){
        .item_right{
          width: 0;
          height: 0;
          border-radius: 0 20px 20px 0;
          background: rgba(9,90,249,1);
        }
        .item{
          padding-left: 20px;
        }
      }
      .formTabButtonInfo{
        display: flex;
        align-items: flex-end;
        margin-top: 30px;
        .item_left{
          width: 0;
          height: 0;
          border-bottom: 49px solid transparent; /* 上边框设置为透明 */
          border-right: 30px solid rgba(9,90,249,1); /* 左边框设置为黑色，形成三角形 */
        }
        .item_right{
          width: 0;
          height: 0;
          border-top: 49px solid transparent; /* 上边框设置为透明 */
          border-left: 30px solid rgba(9,90,249,1); /* 左边框设置为黑色，形成三角形 */
        }
        .item{
          font-family: 微软雅黑;
          color: white;
          font-size: 22px;
          font-weight: bold;
          //font-weight: normal;
          padding: 10px;
          cursor: pointer;
          background-color: rgba(9,90,249,1);
        }
      }
      .blue:nth-of-type(1){
        .item_left{
          width: 0;
          height: 0;
          border-radius: 20px 0 0 20px;
          background: rgba(255,198,3,1);
        }
        .item{
          padding-right: 20px;
        }
      }
      .blue:nth-of-type(4){
        .item_right{
          width: 0;
          height: 0;
          border-radius: 0 20px 20px 0;
          background: rgba(254,170,4,1);
        }
        .item{
          padding-left: 20px;
        }
      }
      .blue{
        .item{
          background: linear-gradient(84.24deg, rgba(255,198,3,1) 4.1%,rgba(254,170,4,1) 95.13%);
          color: rgba(0,0,0,1);
        }
        .item_left{
          border-right: 30px solid rgba(255,198,3,1); /* 左边框设置为黑色，形成三角形 */
        }
        .item_right{
          border-left: 30px solid rgba(254,170,4,1); /* 左边框设置为黑色，形成三角形 */
        }
      }
    }
    .textListInfo_list{
      display: flex;
      justify-content: space-around;
      padding: 40px 0 40px 0;
      width: 1200px;
      .text_list_left{
        margin-top: 50px;
        .text_list_text{
          font-size: 26px;
          color: rgb(51, 51, 51);
          margin-bottom: 50px;
          font-weight: bold;
        }
        .text_list_title{
          width: 400px;
          font-size: 16px;
          line-height: 30px;
          display: inline-block;
          color: rgb(153, 153, 153);
        }
        .text_list_three{
          background-color: rgba(9,90,249,1);
          width: max-content;
          display: flex;
          align-items: center;
          margin-top: 50px;
          color: white;
          padding: 0 20px;
          font-size: 14px;
          cursor: pointer;
          img{
            width: 40px;
            margin-left: 10px;
          }
        }
      }
      .image_right{
        //animation: ceshi 2s forwards;
        .imgInfo{
          width: 550px;
          height: 500px;
        }
      }
      .image_right2{
        //animation: ceshi 2s forwards;
        display: flex;
        .imgInfo{
          width: 250px;
          height: 504px;
        }
      }
    }
  }

  .three{
    background-image: url('/intelligentGuidance/10.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    justify-content: center;
    .three_info{
      margin-top: 80px;
      width: 1400px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .three_left{
        color: white;
        min-width: 400px;
        .three_left_name{
          font-size: 24px;

        }
        .three_left_title{
          font-size: 15px;
          max-width: 400px;
          margin-top: 20px;
        }
      }
      .three_right{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .three_right_info{
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 20px;
          margin-left: 50px;
          margin-bottom: 50px;
          background-color: rgba(14,84,237,1);
          color: white;
          width: 22.5%;
          height: 200px;
          img{
            width: 90px;
            height: 90px;
          }
          .three_text{
            margin-top: 4px;
          }
          .three_title{
            margin-top: 8px;
            max-width: 230px;
            font-size: 15px;
          }
        }
      }
    }

  }


  .four {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 60px 60px 30px 60px;
    .lightModuleOuterContent_text {
      display: flex;
      align-items: center;

      img {
        width: 100px;
      }

      .wenzi {
        font-size: 38px;
        font-weight: bold;
        color: rgb(51, 51, 51);
        margin-left: 40px;
        margin-right: 40px;
      }
    }
    .lightModuleOuterContent_title{
      color: rgba(16,16,16,1);
      font-size: 16px;
      margin-top: 10px;
    }
    .four_image{
      width: 1200px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 20px;
    }
  }
</style>
